/**
 * 证书审核
 * @Author:wuTao
 * @Date 2020/09/20
 */
import React from 'react';
import {connect} from 'dva';

import {component_tool, framework_tool, utils_tool} from '@/tool';
import {modelUtils} from '@/utils';
import moment from "moment";
import '@/styles/containers/train/certApply/certApplyAudit/index.less'

let {WizContainer, WizAvatarUpload, ossFileUtils} = framework_tool

let {Session} = utils_tool;
let {
  WizRow, WizCol, WizCard, WizSpin, WizEmpty,
  WizButton, WizModalForm,WizModal,
} = component_tool;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
};
const formatterTime = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
};
const formatterDay = (val) => {
  return val ? moment(val).format('YYYY-MM-DD') : '';
};

const getFile = (fileId, fileName, fileMimeType, fileSize, fileUri) => {
  return ossFileUtils.getOssFile(
    fileId, fileName, fileMimeType, fileSize, fileUri,
  );
}



class CertApplyAuditDetail extends WizContainer {

  componentName = 'certApplyAuditDetail';

  constructor(props) {
    super(props);
    const {history} = props;
    let initialValue = {};
    if (history.location.record) {
      initialValue = history.location.record;
      Session.set('certApplyCheckDetailInfo', initialValue)
    } else {
      initialValue = Session.get('certApplyCheckDetailInfo') || {};
    }
    let {checkState} = initialValue;
    this.state = {
      visibleAudit: false,
      initCheckState: checkState,
      checkState: checkState,
      fileList: [],
      auditModalKey: new Date().getTime(),
      previewImgVisible: false,
      previewImgKey: new Date().getTime(),
      previewImage: '',
    };
    /** 是否审核*/
    let isShowAuditBut = true;
    /** 是否审核*/
    let isAudit = false;
    /** 是否变更申请*/
    let isChangeApply = false;
    /** 审核是否显示下一个按钮*/
    let isShowNextBut = false;
    /** 判断是审核页面，还是查看页面*/
    if (history.location && history.location.pathname === '/certApply/certApplyList/certApplyAuditDetail') {
      isAudit = true;
    }
    this.isShowAuditBut = isShowAuditBut;
    this.isShowNextBut = isShowNextBut;
    this.isAudit = isAudit;
    this.isChangeApply = isChangeApply;
    this.initialValue = initialValue;
    this.initialValue.oldCertApplyDetail = {};
    this.initialValue.newCertApplyDetail = {};
    this.isSubmit = false;
  }

  _componentDidMount() {
    //获取初始化申请数据
    if (this.initialValue && this.initialValue.id) {
      //查询获取待审核证书申请信息
      this.getCertApplyWaitingAudit(this.initialValue.id, 0)
    }
  }

  /**查询获取下一条待审核证书申请信息 */
  getCertApplyWaitingAudit(id, isNext) {
    let isAudit = this.isAudit;
    if (isAudit && isAudit){
      this.doAction({
        path: 'certApply/getCertApplyInfoById',
        payload: {
          key: 'certApplyWaitingAudit',
          apiParams: {
            id,
            next: isNext,
            checkState:0,
          }
        }
      });
    }else {
      this.doAction({
        path: 'certApply/getCertApplyInfoById',
        payload: {
          key: 'certApplyWaitingAudit',
          apiParams: {
            id,
            next: isNext,
          }
        }
      });
    }
  }

  /**查询获取证书申请照片信息 */
  getCertApplyImgInfo(fileIdList) {
    if (!fileIdList || fileIdList.length == 0) {
      return;
    }
    this.doAction({
      path: 'ossUpload/getFileInfoList',
      payload: {
        key: 'fileInfoList',
        apiParams: {
          fileIdList
        }
      }
    });
  }

  propsAndStateOnChange = {
    certApplyWaitingAudit: this._getCertApplyWaitingAuditOver.bind(this),
    certApplyCheck: this._getCertApplyCheckOver.bind(this),
    fileInfoList: this._getFileInfoListOver.bind(this),
  };

  /**
   * 获取审核证书申请信息
   */
  _getCertApplyWaitingAuditOver(nextProps, nextState) {
    let waitingAudit = nextProps.certApplyWaitingAudit.data;
    if (nextProps.certApplyWaitingAudit.code == 1) {
      if (waitingAudit && waitingAudit.id){
        Session.set('certApplyCheckDetailInfo', waitingAudit);
        let waitApplyNum = !waitingAudit || !waitingAudit.waitApplyNum ? 0 : waitingAudit.waitApplyNum;
        this.isShowNextBut = waitApplyNum >= 1 ? true : false;
        nextState.checkState = waitingAudit.checkState;
        nextState.initCheckState = waitingAudit.checkState;
        nextState.auditModalKey = new Date().getTime();
        const {checkState, list,applicationType} = waitingAudit;
        let fileIdList = [];
        let oldCertApplyDetail = {};
        let newCertApplyDetail = {};
        let isChangeApply = false;
        if (list && list instanceof Array && list.length > 0) {
          list.forEach(certApplyDetail => {
            const {fieldName, fieldValueBefore, fieldValueAfter} = certApplyDetail;
            oldCertApplyDetail[fieldName] = fieldValueBefore;
            newCertApplyDetail[fieldName] = fieldValueAfter;
            if (fieldName === 'imgMain' || fieldName === 'imgSecondary') {
              if (fieldValueBefore && fieldValueBefore != null && fieldValueBefore != '') {
                fileIdList.push(fieldValueBefore)
              }
              if (fieldValueAfter && fieldValueAfter != null && fieldValueAfter != '') {
                fileIdList.push(fieldValueAfter)
              }
            }
          })
        }
        if (applicationType!=null && applicationType===1){
          isChangeApply = true;
        }
        this.isChangeApply = isChangeApply;
        if (!checkState || checkState === 0) {
          this.isShowAuditBut = true;
        } else {
          this.isShowAuditBut = false;
        }
        waitingAudit.oldCertApplyDetail = oldCertApplyDetail;
        waitingAudit.newCertApplyDetail = newCertApplyDetail;
        this.initialValue = waitingAudit;
        this.isSubmit = false;
        // this.getCertApplyImgInfo(fileIdList)
      }else {
        let isSubmit = this.isSubmit;
        if (isSubmit && isSubmit){
          this.isShowAuditBut = false;
        }
        wizNotice.error('暂无待审核数据！');
      }
    } else {
      wizNotice.error('获取证书申请信息失败：' + nextProps.certApplyCheck.msg);
    }
    return true;
  }

  /**
   *提交审核返回结果
   */
  _getCertApplyCheckOver(nextProps, nextState) {
    let certApplyCheck = nextProps.certApplyCheck.data;
    if (nextProps.certApplyCheck.code == 1) {
      nextState.visibleAudit = false;
      nextState.auditModalKey = new Date().getTime();
      nextState.initCheckState = this.state.checkState
      this.isSubmit = true;
      //查询待审核证书申请信息最新状态
      this.getCertApplyWaitingAudit(this.initialValue.id, 0)
    } else {
      wizNotice.error('审核提交失败：' + nextProps.certApplyCheck.msg);
    }
    return true;
  }

  /**
   *提交审核返回结果
   */
  _getFileInfoListOver(nextProps, nextState) {
    let fileInfoList = nextProps.fileInfoList.data;
    if (nextProps.fileInfoList.code == 1) {
      //查询待审核证书申请信息最新状态
      if (fileInfoList && fileInfoList instanceof Array && fileInfoList.length > 0) {
        let fileList = [];
        fileInfoList.forEach(fileInfo => {
          const {fileId} = fileInfo;
          fileList[fileId] = fileInfo;
        });
        nextState.fileList = fileList;
      }
    } else {
      wizNotice.error('获取证书图片失败：' + nextProps.fileInfoList.msg);
    }
    return true;
  }

  /** 证书内容明细展示*/
  _showDetailInfo(title1, value1, title2, value2) {
    return (
      title2 ? (
        <WizRow className='certApplyAudit-row-item'>
          <WizCol className='col-item' span={3} offset={1}>{title1 + '：'}</WizCol>
          <WizCol span={8}>
            {value1 && value1}
          </WizCol>
          <WizCol className='col-item' span={3} offset={1}>{title2 + '：'}</WizCol>
          <WizCol span={8}>
            {value2 && value2}
          </WizCol>
        </WizRow>
      ) : (
        <WizRow className='certApplyAudit-row-item'>
          <WizCol className='col-item' span={3} offset={1}>{title1 + '：'}</WizCol>
          <WizCol span={19}>
            {value1 && value1}
          </WizCol>
        </WizRow>
      )
    )
  }

  /** 审核内容明细页面展示
   * @param title1 旧数据字段名称
   * @param value1 旧数据字段值
   * @param title2 新数据字段名称
   * @param value2 新数据字段值
   * @param isChangeApply 是否变更审核还是新增审核
   *
   * */
  _showAuditDetailInfo(title1, value1, title2, value2, isChangeApply) {
    return (
      isChangeApply ? (
        <WizRow className='certApplyAudit-row-item'>
          <WizCol className='col-item' span={3} offset={1}>{title1 + '：'}</WizCol>
          <WizCol span={8}>
            {value1 && value1}
          </WizCol>
          <WizCol className='col-item' span={3} offset={1}>{title2 + '：'}</WizCol>
          <WizCol span={8}>
            {value1 === value2 ? '':
              (
                <span style={{color: 'red'}}>{value2 && value2}</span>
              )}
          </WizCol>
        </WizRow>
      ) : (
        <WizRow className='certApplyAudit-row-item'>
          <WizCol className='col-item' span={3} offset={1}>{title2 + '：'}</WizCol>
          <WizCol span={19}>
            {value2 && value2}
          </WizCol>
        </WizRow>
      )
    )
  }

  /** 审核内容明细页面展示*/
  _stepNext = () => {
    //查询获取待审核证书申请信息
    this.getCertApplyWaitingAudit(this.initialValue.id, 1)
  }

  /** 打开审核提交框*/
  _openModal = (checkState) => {
    this.setState({
      visibleAudit: true,
      checkState: checkState,
      auditModalKey: new Date().getTime(),
    })
  }

  /** 审核提交框字段*/
  _columnsAudit = [
    {
      formItem: {
        type: "hidden",
      },
      dataIndex: "id",
      name: "id"
    },
    {
      title: "审核意见",
      name: "checkOpinion",
      dataIndex: "checkOpinion",
      formItem: {
        type: 'textarea',
        rows: 4,
        placeholder: '请输入审核意见(选填)，最多300个字',
        maxLength: 300,
      }
    },
  ]

  /** 取消审核提交框*/
  _onChangeCancelForm() {
    const {initCheckState} = this.state;
    this.setState({
      visibleAudit: false,
      checkState: initCheckState,
      auditModalKey: new Date().getTime(),
    })
  }

  /** 确认审核提交框*/
  _onChangeSubmitForm(values) {
    let fitterValues = this.fitterFieldsValue(values);
    this.doAction({
      path: 'certApply/check',
      payload: {
        key: 'certApplyCheck',
        apiParams: {
          ...fitterValues
        }
      }
    });
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    fitterValues.checkState = this.state.checkState;
    return fitterValues;
  }

  _renderFooter = () => {
    return (
      <WizRow className='audit-submit-button-row'>
        <WizCol>
          <WizButton title='保存' icon='check' type='primary' htmlType='submit'>保存</WizButton>
          <WizButton title='取消' onClick={() => this._onChangeCancelForm()}>取消</WizButton>
        </WizCol>
      </WizRow>
    )
  }

  certImg = (fileId, fileName, fileMimeType, fileSize, fileUri) => {
    // let file = getFile(fileId, fileName, fileMimeType, fileSize, fileUri);
    return (
      <img src ={getOssFilePath(fileId)} style={{height: 100, width: 200}} onClick={p => this.handlePreview(getOssFilePath(fileId))}/>
      // <img src={file.url} style={{height: 100, width: 200}}/>
    )
  }

  /** 获取图片*/
  _getImg(fileId) {
    // const {fileList} = this.state;
    // if (fileId && fileList[fileId]) {
    //   let file = fileList[fileId];
    //   const {fileId, fileOriginalName, fileMimeType, fileSize, fileUri} = file;
    //   return certImg(fileId, fileOriginalName, fileMimeType, fileSize, fileUri)
    // } else {
    //   return null;
    // }
    if (fileId) {
      return this.certImg(fileId, null, null, null, null)
    } else {
      return null;
    }
  }

  /** 打开图片查看*/
  handlePreview = async element => {
    this.setState({
      previewImage: element,
      previewImgVisible: true,
      previewImgKey: new Date().getTime(),
    });
  };

  /** 关闭查看Model*/
  handleCancel = () => this.setState({
    previewImgVisible: false
  });

  _render() {
    const {certApplyLoading, ossUploadLoading} = this.props;
    const {visibleAudit, auditModalKey, checkState, fileList} = this.state;
    let initialValue = this.initialValue;
    if(initialValue.mobile !== ''&& initialValue.mobile !== null && initialValue.mobile !== undefined) {
      initialValue.mobile=initialValue.mobile.replace(/^(.{3})(?:\d+)(.{4})$/, "$1****$2");
    }
    let isShowAuditBut = this.isShowAuditBut;
    if (initialValue.checkState != checkState) {
      initialValue.checkState = checkState;
    }
    let isShowNextBut = this.isShowNextBut;
    let isChangeApply = this.isChangeApply;
    let columns = this._columnsAudit;
    let modalFormProps = {
      title: '审核提交',
      key: auditModalKey,
      loading: false,
      record: initialValue,
      visible: visibleAudit,
      columns,
      // footer: this._renderFooter(),
      modalOpts: {
        width: 700
      },
      onCancel: () => this._onChangeCancelForm(),
      onSubmit: values => this._onChangeSubmitForm(values)
    }
    return (
      <>
        <WizSpin tip={'加载中'} spinning={certApplyLoading || ossUploadLoading}>
          {
            this.isAudit && (
              <WizCard bodyStyle={{padding: 0}}>
                <WizRow className='certApplyAudit-row-item'>
                  <WizCol className='col-item-left' span={11} offset={1}>
                    <WizRow className='audit-button-row'>
                      <WizCol>
                        {isShowAuditBut ?
                          <WizButton type="primary" onClick={() => this._openModal(1)}>通过</WizButton> : null}
                        {isShowAuditBut ?
                          <WizButton type="danger" onClick={() => this._openModal(2)}>不通过</WizButton> : null}
                        {isShowNextBut ? <WizButton onClick={() => this._stepNext()}>下一个</WizButton> : null}
                      </WizCol>
                    </WizRow>
                  </WizCol>
                  <WizCol className='col-item-right' span={11}>
                    <span style={{color: 'red',}}>
                      {'待审批 ' + (!this.initialValue.waitApplyNum ? 0 : this.initialValue.waitApplyNum) + ' 条'}
                    </span>
                  </WizCol>
                </WizRow>
              </WizCard>
            )
          }
          <WizCard title={'申请信息'}>
            {this._showDetailInfo('申请证书', initialValue.certName && initialValue.certName, '申请时间', initialValue.applyDate && formatterTime(initialValue.applyDate))}
            {this._showDetailInfo('姓名', initialValue.fullName && initialValue.fullName, '账号', initialValue.account && initialValue.account)}
            {this._showDetailInfo('电话号码', initialValue.mobile && initialValue.mobile, '审核状态', !this.state.initCheckState || this.state.initCheckState === 0 ? '待审核' : (this.state.initCheckState === 1 ? '通过' : '未通过'))}
            {!this.isAudit && this._showDetailInfo('审核意见', initialValue.checkOpinion && initialValue.checkOpinion, null, null)}
          </WizCard>
          {/* 正常展示框*/}
          <WizCard icon='0' title={!isChangeApply ? '申请内容' :
            (
              <span className='wizCard-title-span'>
                <span className='small-title-span'>{'原始数据'}</span>
                <span className='small-title-span'>{'修改申请数据'}</span>
              </span>
            )}>
            {this._showAuditDetailInfo('证书名称', initialValue.certName && initialValue.certName,
              '证书名称', initialValue.certName && initialValue.certName, isChangeApply)}
            {this._showAuditDetailInfo('证书编码', initialValue.oldCertApplyDetail.certCode && initialValue.oldCertApplyDetail.certCode,
              '证书编码', initialValue.newCertApplyDetail.certCode && initialValue.newCertApplyDetail.certCode, isChangeApply)}
            {this._showAuditDetailInfo('颁证单位', initialValue.oldCertApplyDetail.awardUnit && initialValue.oldCertApplyDetail.awardUnit,
              '颁证单位', initialValue.newCertApplyDetail.awardUnit && initialValue.newCertApplyDetail.awardUnit, isChangeApply)}
            {this._showAuditDetailInfo('生效日期', initialValue.oldCertApplyDetail.startDate && formatterDay(moment(initialValue.oldCertApplyDetail.startDate)),
              '生效日期', initialValue.newCertApplyDetail.startDate && formatterDay(moment(initialValue.newCertApplyDetail.startDate)), isChangeApply)}
            {this._showAuditDetailInfo('失效日期', initialValue.oldCertApplyDetail.endDate && formatterDay(moment(initialValue.oldCertApplyDetail.endDate)),
              '失效日期', initialValue.newCertApplyDetail.endDate && formatterDay(moment(initialValue.newCertApplyDetail.endDate)), isChangeApply)}
            {this._showAuditDetailInfo('复审日期', initialValue.oldCertApplyDetail.reCheckDate && formatterDay(moment(initialValue.oldCertApplyDetail.reCheckDate)),
              '复审日期', initialValue.newCertApplyDetail.reCheckDate && formatterDay(moment(initialValue.newCertApplyDetail.reCheckDate)), isChangeApply)}
            {this._showAuditDetailInfo('初领日期', initialValue.oldCertApplyDetail.firstDate && formatterDay(moment(initialValue.oldCertApplyDetail.firstDate)),
              '初领日期', initialValue.newCertApplyDetail.firstDate && formatterDay(moment(initialValue.newCertApplyDetail.firstDate)), isChangeApply)}
            {this._showAuditDetailInfo('证书照片(正面)', this._getImg(initialValue.oldCertApplyDetail.imgMain),
              '证书照片(正面)', this._getImg(initialValue.newCertApplyDetail.imgMain), isChangeApply)}
            {this._showAuditDetailInfo('证书照片(反面)', this._getImg(initialValue.oldCertApplyDetail.imgSecondary),
              '证书照片(反面)', this._getImg(initialValue.newCertApplyDetail.imgSecondary), isChangeApply)}
          </WizCard>
          <WizModal key={'img_preview_' + this.state.previewImgKey} visible={this.state.previewImgVisible} footer={null} 
                    onCancel={this.handleCancel}>
            <img alt="example" style={{width: '100%'}} src={this.state.previewImage}/>
          </WizModal>
        </WizSpin>
        <WizModalForm {...modalFormProps} />
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {certApply, ossUpload} = state;
  const certApplyWaitingAudit = modelUtils.getModelEntity(certApply, "certApplyWaitingAudit");
  const certApplyCheck = modelUtils.getModelEntity(certApply, 'certApplyCheck');
  const fileInfoList = modelUtils.getModelEntity(ossUpload, 'fileInfoList');
  const load = modelUtils.getLoadingState(state, ['certApply', 'ossUpload']);
  return {
    certApplyCheck: certApplyCheck,
    certApplyWaitingAudit: certApplyWaitingAudit,
    fileInfoList: fileInfoList,
    ...load
  }
};

export default connect(mapStateToProps)(CertApplyAuditDetail);
